<template>
  <div class="age-range-config">
    <div class="age-range-config--toggle">
      <InputCheckbox
        v-model="internalEnabled"
        :checked="internalEnabled"
        :disabled="disabled"
        label="Configurar limite por faixa etária infantil"
      />

      <PmwInfoTooltip width="280px" placement="bottom">
        <template #content>
          O preenchimento é <strong>obrigatório para salvar.</strong> Caso o
          hotel <strong>não aceite</strong> determinada faixa etária,
          <strong>insira o valor &quot;0&quot;.</strong> Se não houver restrição
          específica, informe a capacidade máxima de crianças do quarto. Obs: Os
          limites por faixa não se somam.
        </template>
      </PmwInfoTooltip>
    </div>

    <div v-if="internalEnabled" class="age-range-config--table">
      <table>
        <thead>
          <tr>
            <th class="age-range-config--col__faixa">
              <span class="age-range-config--th-faixa">
                Faixa
                <PmwInfoTooltip width="280px" placement="bottom">
                  <template #content>
                    Para alterar as faixas já configuradas,
                    <a
                      class="age-range-config--tooltip-link"
                      href="mailto:suporteplataformas@pmweb.com.br"
                      >entre em contato com o time de atendimento.</a
                    >
                  </template>
                </PmwInfoTooltip>
              </span>
            </th>
            <th class="age-range-config--col__minmax">
              Máximo <span class="age-range-config--required">*</span>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(range, idx) in internalRanges" :key="idx">
            <td class="age-range-config--cell">
              <span class="age-range-config--label">{{ range.label }}</span>
            </td>
            <td class="age-range-config--cell">
              <PmwFormInput
                v-model="range.limite"
                :required="true"
                size="small"
                label=""
                placeholder="0"
                type="number"
                class="age-range-config--input"
              />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import InputCheckbox from '@/components/_base/elements/InputCheckbox'
import PmwFormInput from '@solucoes/components-lib-tmp/src/components/patterns/PmwFormInput'
import PmwInfoTooltip from '@solucoes/components-lib-tmp/src/components/patterns/PmwInfoTooltip'

export default {
  name: 'AgeRangeConfig',

  components: { InputCheckbox, PmwFormInput, PmwInfoTooltip },

  props: {
    /** Se a configuração está ativa */
    enabled: { type: Boolean, default: false },

    /** Faixas etárias configuradas */
    ranges: { type: Array, default: () => [] },

    /** Exibir tooltip com link para configuração de faixa etária no hotel */
    showTooltip: { type: Boolean, default: true },

    /** Desabilitar o checkbox quando máximo de crianças for 0 */
    disabled: { type: Boolean, default: false }
  },

  computed: {
    internalEnabled: {
      get() {
        return this.enabled
      },
      set(val) {
        this.$emit('update:enabled', val)
      }
    },
    internalRanges: {
      get() {
        return this.ranges
      },
      set(val) {
        this.$emit('update:ranges', val)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.age-range-config {
  margin-top: 24px;

  &--th-faixa {
    display: flex;
    align-items: center;
    gap: 4px;
  }

  &--tooltip-link {
    color: pmw-colors('blue-100');
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }

  &--toggle {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 19px;

    ::v-deep {
      .input-checkbox--label__overflow {
        white-space: normal;
        overflow: visible;
        text-overflow: unset;
      }

      .input-checkbox--label {
        width: auto;
      }

      .pmw-select--button:focus {
        border-color: pmw-colors('blue-100');
        border-bottom-color: pmw-colors('blue-100');
      }

      .pmw-label {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .pmw-custom-tooltip {
        line-height: 1.5;
      }
    }
  }

  &--table {
    max-width: 560px;

    table {
      th,
      td {
        vertical-align: middle;
        border: 1px solid pmw-colors('grey-20');
        white-space: nowrap;

        & + & {
          border-left: none;
        }
      }

      th {
        padding: 17px 7px 15px 15px;
        font-size: font-size('size-small');
        font-weight: font-weight('weight-medium');
        line-height: 21px;
        color: $gray-darkest;
      }
    }
  }

  &--col {
    &__faixa {
      width: 150px;
      min-width: 150px;
    }

    &__minmax {
      width: 180px;
      min-width: 180px;
    }
  }

  &--cell {
    padding: 0 15px;
    height: 67px;
    font-size: font-size('size-small');
    font-weight: font-weight('weight-medium');
    line-height: 21px;
  }

  &--required {
    color: $error;
  }

  &--label {
    color: $gray-dark;
  }

  &--input {
    width: 120px;

    ::v-deep {
      .pmw-input__focus {
        border-color: $pmw-blue;
      }

      .pmw-form-field--label {
        display: none;
      }

      .pmw-input {
        background: transparent;
      }

      .pmw-input--field {
        background: transparent;
        padding-left: 0;
        padding-right: 0;
        border-top: none;
        border-left: none;
        border-right: none;
        border-radius: 0;
      }

      .pmw-input--clear {
        display: none;
      }
    }
  }
}
</style>
